import type React from 'react';

import * as styles from './styles';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export enum BadgeSidebarType {
  SOON = 'Breve',
  BETA = 'Beta',
  NEW = 'Novo',
  NOTIFICATION = 'Notificação',
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export interface BadgeSidebarProps {
  type: BadgeSidebarType;
  className?: string;
  expired?: boolean;
}

export const badgeColors = {
  [BadgeSidebarType.SOON]: colors.white,
  [BadgeSidebarType.BETA]: colors.accessory._5,
  [BadgeSidebarType.NEW]: colors.success.default,
  [BadgeSidebarType.NOTIFICATION]: colors.error.default,
};

export const BadgeSidebar: React.FC<BadgeSidebarProps> = ({ type, className, expired = false }) => {
  const color = () => badgeColors[type] || colors.white;

  return expired ? null : <div className={`${styles.badge(color())} ${className || ''}`}>{type}</div>;
};
